// AboutSigmaStudio.jsx
import React, { useState } from 'react';
import MainLayout from '../../layouts/MainLayout';
import '../../styles/Think5WhysHelp.css';

const AboutThink5WhysJobs = () => {
  const topics = [
    {
      title: 'Think5Whys BPMConnect - Job Board',
      description: (
        <div>
          <p>BPMConnect is the Job Board on Think5Whys which is a dedicated platform tailored for
           Business Process Management (BPM) Jobs & Works, providing a centralized hub for 
           job seekers, recruiters, and businesses to explore, connect, and engage.</p>
          <br/>
          <p>With a comprehensive range of features, users can effortlessly navigate through 
          various job-related activities, including seeking job opportunities, posting job listings, 
          accessing instant jobs with immediate availability, and real-time interaction features for seamless communication.</p>
          <br/>
          <p>Additionally, the Job Board ensures credibility and quality assurance through features like 
          verified recruiter profiles and certified freelancers, while also providing tools for tracking job-related 
          activities, monitoring time spent on tasks, and connecting with BPM consultants and industry experts.</p>
          <br/>
          <p>Whether users are seeking employment, recruiting talent, or exploring internship opportunities, 
          the Job Board offers support services for Micro, Small, and Medium Enterprises (MSMEs) and 
          facilitates job payments with assurance measures in place.</p>
          <br/>
          <p>Overall, the Job Board serves as a comprehensive solution for job-related activities within the 
          BPM domain, promoting user interaction, engagement, and collaboration while providing a user-friendly 
          experience tailored to the needs of the Think5Whys community.</p>
        </div>
      ),
    },
    {
      title: 'Think5Whys Job Board Features',
      description: (
        <div>
          <ul>
            <li>Dedicated platform for Business Process Management (BPM) Jobs & Works</li>
            <li>Centralized hub for job seekers, recruiters, and businesses</li>
            <li>Explore job opportunities</li>
            <li>Seek job opportunities</li>
            <li>Post job listings</li>
            <li>Access instant jobs with immediate availability</li>
            <li>Real-time interaction features for seamless communication</li>
            <li>Credibility assurance with verified recruiter profiles</li>
            <li>Certification indication for freelancers</li>
            <li>Tracking tools for job-related activities</li>
            <li>Time monitoring feature for tasks</li>
            <li>Connection with BPM consultants and industry experts</li>
            <li>Support services for Micro, Small, and Medium Enterprises (MSMEs)</li>
            <li>Facilitation of job payments with assurance measures</li>
          </ul>
        </div>
      ),
    },
    {
      title: '🔍 Seek a Job',
      description: (
        <div>
          <p>Find and apply for jobs.</p>
        </div>
      ),
    },
    {
      title: '📝 Post a Job',
      description: (
        <div>
          <p>Post job opportunities for candidates.</p>
        </div>
      ),
    },
    {
      title: '⏰ Instant Jobs',
      description: (
        <div>
          <p>Access jobs with immediate availability.</p>
        </div>
      ),
    },
    {
      title: '💬 Instant Interaction',
      description: (
        <div>
          <p>Real-time communication or interaction features.</p>
        </div>
      ),
    },
    {
      title: '👥 Feedbacks & Ratings',
      description: (
        <div>
          <p>Provide and view feedback on jobs or candidates.</p>
        </div>
      ),
    },
    {
      title: '🔍 Verified Recruiters',
      description: (
        <div>
          <p>Ensures credibility with verified recruiter profiles.</p>
        </div>
      ),
    },
    {
      title: '📜 Certified Freelancers',
      description: (
        <div>
          <p>Indicates freelancers with recognized certifications.</p>
        </div>
      ),
    },
    {
      title: '📅 Job Work Diary',
      description: (
        <div>
          <p>Track and manage job-related activities.</p>
        </div>
      ),
    },
    {
      title: '⏱️ Time Tracker',
      description: (
        <div>
          <p>Monitor and log time spent on jobs.</p>
        </div>
      ),
    },
    {
      title: '🔍 BPM Consultants',
      description: (
        <div>
          <p>Connect with consultants specializing in BPM.</p>
        </div>
      ),
    },
    {
      title: '🎓 Experts Services',
      description: (
        <div>
          <p>Access services provided by industry experts.</p>
        </div>
      ),
    },
    {
      title: '🎓 Intern Positions',
      description: (
        <div>
          <p>Explore internship opportunities.</p>
        </div>
      ),
    },
    {
      title: '🛍️ Retail Positions',
      description: (
        <div>
          <p>Find positions in the retail sector.</p>
        </div>
      ),
    },
    {
      title: '🤝 MSME Support',
      description: (
        <div>
          <p>Support services for Micro, Small and Medium Enterprises.</p>
        </div>
      ),
    },
    {
      title: '💳 Job Payments',
      description: (
        <div>
          <p>Information on job-related payments.</p>
        </div>
      ),
    },
    {
      title: '🔒 Job Payment Protection',
      description: (
        <div>
          <p>Assurance or protection measures for job payments.</p>
        </div>
      ),
    },
    {
      title: '🤝 User Interaction and Engagement',
      description: (
        <div>
          <p>Encourages job seekers, recruiters, and businesses to explore, connect, and engage.</p>
          <p>Offers a comprehensive range of features catering to various aspects of job-related activities.</p>
        </div>
      ),
    }
  ];

  const [expandedTopic, setExpandedTopic] = useState(null);

  const handleTopicClick = (index) => {
    setExpandedTopic(expandedTopic === index ? null : index);
  };

  return (
    <MainLayout>
      <div className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>
        <h2>Sigma Studio Help Center</h2>
      </div>
      <div className="help-container">
        <ul className="help-list">
          {topics.map((topic, index) => (
            <li key={index} onClick={() => handleTopicClick(index)} className="help-topic">
              {topic.title}
              {expandedTopic === index && (
                <div className="help-description">
                  <p>{topic.description}</p>
                </div>
              )}
            </li>
          ))}
        </ul>
      </div>
    </MainLayout>
  );
};

export default AboutThink5WhysJobs;


